module.exports = __webpack_public_path__ + "media/react/marketing/sections/value_props/assets/green/video_lessons_icon-652801ea8bf06aa796b39bef8702a649.svg";